import { createMatomoScriptTag } from "../utils/matomoHelpers";
let apiConfig;
let GOOGLE_MAP_API_KEY = "";
let RECAPTCHA_KEY = "";
let CSRF_TOKEN = "";

if (process.env.NODE_ENV !== "production") {
  GOOGLE_MAP_API_KEY = "AIzaSyAAjhDgObWd9E0g4dCJHKMOhqFWFFwt89U";
  RECAPTCHA_KEY = process.env.RECAPTHCA_KEY;
  CSRF_TOKEN = "Test";
  apiConfig = {
    //rootUrl: `http://192.168.0.88:3753${window.location.pathname}/`,
    rootUrl: `http://192.168.2.23:3753${window.location.pathname}/`,
    //rootUrl: "http://192.168.1.100:3753/superaccountyo/",
    headers: { CsrfAngular: CSRF_TOKEN, "content-type": "application/json" }
  };
} else {
  //prod config
  GOOGLE_MAP_API_KEY = "AIzaSyAAjhDgObWd9E0g4dCJHKMOhqFWFFwt89U";
  const prodDomainRegex = /^portal\.coreplus\.com\.au/gi;
  if (prodDomainRegex.test(window.location.hostname)) {
    GOOGLE_MAP_API_KEY = "AIzaSyBO-zbHUAaPTTg5LzwrHIQlmh267AfeXQw";
    createMatomoScriptTag();
  }
  RECAPTCHA_KEY = process.env.RECAPTHCA_KEY;
  const antiForgeryTokenDom = document.querySelector(
    'input[name="__RequestVerificationToken"]'
  );
  const CSRF_TOKEN = antiForgeryTokenDom ? antiForgeryTokenDom.value : "";
  if (!window.location.origin) {
    window.location.origin =
      window.location.protocol +
      "//" +
      window.location.hostname +
      (window.location.port ? ":" + window.location.port : "");
  }
  const rootUrl = `${window.location.origin}/${window.location.pathname}/`;
  apiConfig = {
    rootUrl,
    headers: {
      CsrfAngular: CSRF_TOKEN || "TEST",
      "content-type": "application/json"
    }
  };
}

export { apiConfig, CSRF_TOKEN, GOOGLE_MAP_API_KEY, RECAPTCHA_KEY };



// WEBPACK FOOTER //
// ./src/api/config.js